module.exports = __webpack_public_path__ + "img/服务器.95de3a3a.svg";